import { Typography } from 'antd';
import { formatDisplayInteger } from 'i18n/arabicDigits';
import React from 'react';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

type LocalizedNumberProps = {
  value: number | null | undefined;
  className?: string;
};

/** Renders a count with Arabic-Indic digits when the UI locale is Arabic. */
export const LocalizedNumber: React.FC<LocalizedNumberProps> = ({
  value,
  className,
}) => {
  const { i18n } = useTranslation();
  return (
    <Text className={className}>
      {formatDisplayInteger(value, i18n.language)}
    </Text>
  );
};
